/**
 * Inline checkbox group component
 *
 * @param {Array} options - Array of { key, label, checked }
 * @param {function} onChange - Called with (key, checked) when changed
 * @param {string} className - Additional classes
 */
const CheckboxGroup = ({
  options,
  onChange,
  className = "",
}) => {
  return (
    <div className={`flex items-center gap-4 text-xs ${className}`}>
      {options.map(opt => (
        <label
          key={opt.key}
          className="flex items-center gap-2 cursor-pointer text-base-content/60 hover:text-base-content"
        >
          <input
            type="checkbox"
            className="checkbox checkbox-xs checkbox-primary"
            checked={opt.checked}
            onChange={e => onChange(opt.key, e.target.checked)}
          />
          <span>{opt.label}</span>
        </label>
      ))}
    </div>
  );
};

export default CheckboxGroup;
